import { IQuestion } from 'models/evaluation.model'
import { sanitizeHtml } from 'helpers/sanitizeHtml'
import { MultimediaContentType } from 'enum/multimediaContentType.enum'
import { Wrapper } from './styled'

interface IProps {
  question: IQuestion
}

export const QuestionTitle = ({ question }: IProps) => {
  const getVideoType = () => {
    const extension = question.multimediaContent.split('.').pop()?.toLowerCase()
    switch (extension) {
      case 'mp4':
        return 'video/mp4'
      case 'webm':
        return 'video/webm'
      case 'ogg':
      case 'ogv':
        return 'video/ogg'
      case 'mov':
        return 'video/quicktime'
      default:
        return 'video/mp4'
    }
  }

  return (
    <Wrapper>
      {question.multimediaContentType === MultimediaContentType.image && (
        <img src={question.multimediaContent} />
      )}
      {question.multimediaContentType === MultimediaContentType.video && (
        <video controls>
          <source src={question.multimediaContent} type={getVideoType()} />
        </video>
      )}
      {question.multimediaContentType === MultimediaContentType.code && (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(question.multimediaContent),
          }}
        />
      )}
    </Wrapper>
  )
}

export default QuestionTitle
